export default {
    name: 'getApp',
    data : function(){
        return {

        }
    },
}